export default {
    items: [],
    cbs: [],
    loading: false,
    page: 1,
}